import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import Headerinner from "../layouts/Headerinner";
import Breadcrumbs from "../layouts/Breadcrumb";
import Footer from "../layouts/Footer";
import Content from "../sections/checkout/Content";
import services from "../../api/services";
import Preloader from "../layouts/Preloader";
import Headersticky from "../layouts/Headersticky";
import { getRestaurant } from "../../utils/commons";

const Checkout = () => {
	const [state, setState] = useState({
		isReady: false,
		restaurant: null,
		categories: [],
		allItems: [],
		totalPrice: [],
	});

	const restaurant = getRestaurant();

	useEffect(() => {
		// Appel recuperer infos du restaurant
		document.documentElement.style.overflowY = "scroll";
		services.getRestaurantInfos(
			restaurant.restaurantId,
			(res) => {
				let restaurant = res.restaurant[0];
				setState({
					...state,
					restaurant: restaurant,
					isReady: true,
					loading: false,
				});

				// localStorage.setItem("restaurant", JSON.stringify(restaurant));
			},
			(err) => {
				console.warn(err.status);
			}
		);
	}, []);

	return state.restaurant ? (
		<Fragment>
			<MetaTags>
				<title>{state.restaurant.name} | Mon panier</title>
				<meta name="description" content="#" />
			</MetaTags>
			<Headerinner />
			<Headersticky />
			<Breadcrumbs
				breadcrumb={{
					pagename: state.restaurant.name,
					// subtitle: "Commandez en ligne",
				}}
			/>
			<Content restaurant={state.restaurant} />
			<Footer
				footer={{
					style: "ct-footer footer-dark",
					logo: "assets/img/logo-light.png",
				}}
			/>
		</Fragment>
	) : (
		<Preloader />
	);
};

export default Checkout;
